import React from 'react'

import { Card } from '@acorns/web-components'
import { Button } from '@acorns/web-components'
import styled from 'styled-components'

import SidebarFrame from 'components/SidebarFrame'
import { Bodytext, Heading } from 'components/typography'
import { User } from 'generated/types'
import { useSupportChat } from 'hooks/useSupportChat'
import theme from 'theme'

import LockedNav from './lockedNav'
import SpendLockedImg from './spend-locked-account.svg'

interface Props {
  authData: {
    user: User
  }
}

const StyledButton = styled(Button)`
  width: 90%;
  max-width: 380px;
  margin: 0 auto;

  @media (max-width: ${theme.breakpoints.sm}px) {
    width: 90%;
    max-width: 295px;
  }
`
const StyledCard = styled(Card)`
  width: 100%;
  max-width: 420px;
  height: 398px;
  margin: 12% auto auto;

  @media (max-width: ${theme.breakpoints.md}px) {
    margin: 10% auto auto;
  }

  @media (max-width: ${theme.breakpoints.sm}px) {
    margin: 5% auto auto;
    max-width: 335px;
    height: 461px;
  }
`

const CardImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin: 50px auto 24px;

  @media (max-width: ${theme.breakpoints.sm}px) {
    margin: 20% auto 24px;
  }
`

const CardMessage = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  margin-top: 40px;
  overflow: auto;

  @media (max-width: ${theme.breakpoints.sm}px) {
    margin-top: 3%;
  }
`

const CardHeader = styled(Heading)`
  margin-bottom: 8px;
  text-align: center;
`

const CardBody = styled(Bodytext)`
  max-width: 300px;
  height: 38px;
  text-align: center;
  color: ${theme.colors.slate};
  margin: 0 auto 20px;

  @media (max-width: ${theme.breakpoints.sm}px) {
    max-width: 275px;
  }
`

const LockedAccount = (props: Props) => {
  const { openSupportChat } = useSupportChat({
    email: props.authData.user.email ?? '',
  })

  const renderNav = () => {
    return <LockedNav />
  }

  return (
    <SidebarFrame renderNav={renderNav}>
      <StyledCard>
        <CardMessage>
          <CardImage alt="locked-account-image" src={SpendLockedImg} />
          <CardHeader>Account Locked</CardHeader>
          <CardBody>
            Your Acorns Checking account is locked. Please contact customer
            support.
          </CardBody>
          <StyledButton onPress={openSupportChat}>
            {'Contact Support'}
          </StyledButton>
        </CardMessage>
      </StyledCard>
    </SidebarFrame>
  )
}

export default LockedAccount
